import { jsx as _jsx } from "react/jsx-runtime";
import { DashboardDetail } from '../../components/dashboard_detail/dashboard_detail.component';
const DashboardDetailPage = () => {
    return _jsx(DashboardDetail, {});
};
export default DashboardDetailPage;
